export default "__VITE_ASSET__B2kgTIPW__"